import React, { PropTypes } from 'react'
import Card from 'components/Card'
import Button from 'components/Button'
import styles from './Documents.scss'
// import IconEPICPDF from 'icons/IconEPICPDF'
import IconEPICDocument from 'icons/IconEPICDocument'
import IconDelete from 'icons/IconDelete'
import epicPdf from 'icons/svg/EPICPDF.svg'
import Heading from 'components/Heading'
import BackToAdminCentre from 'components/BackToAdminCentre'
import { Link } from 'react-router-dom'
import { setReportUrl } from 'actions/reports'

const Documents = ({
  documentsArray, isPdf, title, backToAdminCentreText, isAdmin, openInNewTab = '_blank', isLink = false, dispatch, deleteDocument, hasDeleteAccess, noRecordText = 'No documents found',
}) => {
  if (isLink) {
    // isLink true
  } else {
    // isLink false
  }
  if (documentsArray.length > 0) {
    return (
      <div>
        <Heading className={styles.sectionTitle} />
        <BackToAdminCentre displayText={backToAdminCentreText} isAdmin={isAdmin} />
        <Card noPadding >
          <div className={styles.rowWrapper}>
            <div className={styles.subHeader}>{title}</div>
          </div>
          {documentsArray.map((doc, key) =>
          (<div className={styles.rowWrapper} key={key}>
            {isPdf ? <img alt="" className={styles.pdfIcon} src={epicPdf} /> : <IconEPICDocument className={styles.pdfIcon} />}
            {/* {isPdf ? <IconEPICPDF className={styles.pdfIcon} /> : <IconEPICDocument className={styles.pdfIcon} />} */}
            <div className={styles.fileName}>{doc.Name}</div>
            {(isLink ? <Link className={styles.viewText} onClick={() => { dispatch(setReportUrl(doc.ReportUrl, doc.ID != null ? doc.ID : doc.ItemID)) }} to={doc.URL}>VIEW</Link> : <a className={styles.viewText} href={doc.URL} target={openInNewTab}>VIEW</a>)}
            {isAdmin && hasDeleteAccess &&
            <div>
              <Button
                onClick={() => {
                deleteDocument(doc.ItemID)
              }}
                type="flat"
              >
              DELETE
            </Button></div>}
          </div>))}
        </Card>
      </div>
    )
  }

  return (
    <div>
      <Heading className={styles.sectionTitle} />
      <BackToAdminCentre displayText={backToAdminCentreText} isAdmin={isAdmin} />
      <Card><div>{noRecordText}</div></Card>
    </div >
  )
}

Documents.propTypes = {
  documentsArray: PropTypes.array.isRequired,
  isPdf: PropTypes.boolean,
  title: PropTypes.string.isRequired,
}

export default Documents



// WEBPACK FOOTER //
// ./src/components/Documents/Documents.js